import { render, staticRenderFns } from "./BusinessCharacteristicsView.vue?vue&type=template&id=19d37090&scoped=true&"
import script from "./BusinessCharacteristicsView.vue?vue&type=script&lang=ts&"
export * from "./BusinessCharacteristicsView.vue?vue&type=script&lang=ts&"
import style0 from "./BusinessCharacteristicsView.vue?vue&type=style&index=0&id=19d37090&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19d37090",
  null
  
)

export default component.exports